import {useCallback, useState} from 'react';
import type {Job} from '@cp/model';
import {jobCreateSeedQuestionVariant} from '../../api/callable/jobs';

export function useCreateSeedQuestionVariantJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const createSeedQuestionVariantJob = useCallback(
    async (moduleId: string, seedQuestionCount: number, variantsPerSeed?: number, runLimit?: number): Promise<Job> => {
      setLoading(true);
      setError(undefined);
      try {
        return await jobCreateSeedQuestionVariant({moduleId, seedQuestionCount, variantsPerSeed, runLimit});
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createSeedQuestionVariantJob,
    loading,
    error,
  };
}
